<p-drawer
  [(visible)]="visible"
  [position]="'right'"
  [style]="{ width: '500px' }"
  [modal]="true"
  (onHide)="close()">
  <ng-template pTemplate="header">
    <div class="drawer-header">
      <img src="/twilio.svg" class="twilio-icon" alt="Twilio" />
      <h2>Connect phone number using Twilio</h2>
    </div>
  </ng-template>

  <div
    class="drawer-content"
    snAssistantSurface="importNumber"
    i18n-surfaceTitle="@@importNumber.surface"
    surfaceTitle="Connect a phone number">
    @if (!showAddAccountForm) {
      <!-- Label -->
      <div class="form-field">
        <label for="label" class="field-label">Label</label>
        <input
          pInputText
          id="label"
          [(ngModel)]="label"
          [snAssistantId]="F.label"
          placeholder="Easy to identify name of the phone number"
          class="w-full">
      </div>
    }

    @if (!showAddAccountForm) {
      <!-- Twilio Account SID -->
      <div class="form-field">
        <label for="account" class="field-label">Twilio Account SID</label>

        <p-select
          [(ngModel)]="selectedAccountId"
          [snAssistantId]="F.account"
          snAssistantLabel="Twilio account"
          [options]="accountOptions"
          placeholder="Select an existing SID or enter a new one"
          [disabled]="isLoadingAccounts"
          [filter]="true"
          [showClear]="true"
          filterPlaceholder="Search accounts..."
          [loading]="isLoadingAccounts"
          (onChange)="onAccountChange()"
          class="w-full"
          styleClass="w-full">
        </p-select>

        <p-button
          label="Add New Account"
          icon="pi pi-plus"
          severity="secondary"
          [outlined]="true"
          size="small"
          class="add-account-btn"
          (click)="showAddAccountFormClick()">
        </p-button>
      </div>
    }

    @if (!showAddAccountForm) {
      <!-- Phone Number -->
      <div class="form-field">
        <label for="phoneNumber" class="field-label">Phone number</label>

        @if (phoneNumbersLoadError) {
          <div class="error-state">
            <p class="error-message">Failed to load phone numbers</p>
            <p-button
              label="Reload"
              icon="pi pi-refresh"
              size="small"
              (click)="reloadPhoneNumbers()">
            </p-button>
          </div>
        } @else {
          <p-select
            [(ngModel)]="selectedPhoneNumber"
            [snAssistantId]="F.phoneNumber"
            snAssistantLabel="Phone number"
            [options]="phoneNumberOptions"
            placeholder="Select a phone number"
            [filter]="true"
            [showClear]="true"
            filterPlaceholder="Search phone numbers..."
            [loading]="isLoadingPhoneNumbers"
            [disabled]="isLoadingPhoneNumbers || !selectedAccountId"
            class="w-full"
            styleClass="w-full">
          </p-select>
        }
      </div>
    }

    <!-- Add New Account Card -->
    @if (showAddAccountForm) {
      <p-card class="add-account-card">
        <div class="form-field">
          <label for="accountSid" class="field-label">Twilio Account SID</label>
          <input
            pInputText
            id="accountSid"
            [(ngModel)]="newAccountSid"
            snAssistantSkip
            placeholder="Enter Twilio Account SID"
            class="w-full">
        </div>

        <div class="form-field">
          <label for="authToken" class="field-label">Twilio Account Auth Token</label>
          <input
            pInputText
            id="authToken"
            type="password"
            [(ngModel)]="newAccountAuthToken"
            snAssistantSkip
            placeholder="Enter Twilio Auth Token"
            class="w-full">
        </div>

        <div class="card-actions">
          <p-button
            label="Cancel"
            severity="secondary"
            [outlined]="true"
            size="small"
            (click)="cancelAddAccount()"
            [disabled]="isAddingAccount">
          </p-button>
          <p-button
            [label]="isAddingAccount ? 'Adding...' : 'Add New Account'"
            size="small"
            [icon]="isAddingAccount ? 'pi pi-spin pi-spinner' : ''"
            (click)="addNewAccount()"
            [disabled]="isAddingAccount || !newAccountSid || !newAccountAuthToken">
          </p-button>
        </div>
      </p-card>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="drawer-footer">
      <p-button
        label="Cancel"
        severity="secondary"
        [outlined]="true"
        (click)="close()"
        [disabled]="isImporting">
      </p-button>
      <p-button
        [label]="isImporting ? 'Connecting...' : 'Connect'"
        [icon]="isImporting ? 'pi pi-spin pi-spinner' : ''"
        (click)="import()"
        snAssistantAction="import"
        actionHint="Connects the chosen number to the workspace. Calls to it start reaching the agent it gets assigned to."

        [disabled]="!selectedPhoneNumber || !selectedAccountId || isImporting"
        [loading]="isImporting">
      </p-button>
    </div>
  </ng-template>
</p-drawer>
